export class MetricsCompactAccountsSummaryModel {
    active;
    searchableAccounts;
}
//# sourceMappingURL=metrics-compact-accounts-summary.js.map